module.exports = __webpack_public_path__ + "static/img/静止.e01340f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/越野车/静止.png
// module id = ysAc
// module chunks = 76